const ConnectionWithInnovationCenter = () => {
    return (
        <section className="section">
            <div className="container">
                <div className="center-connection">
                    <h3><i className="fas fa-link"></i> ارتباط رویداد با مرکز نوآوری مشترک آب و محیط زیست</h3>
                    <p>
                        تمامی مراحل رویداد، از ایده‌پردازی تا اجرای آزمایشی، با طراحی علمی و ساختاریافته، مسیر شکل‌گیری و
                        تقویت مرکز ملی نوآوری آب را هموار می‌کند. تیم‌ها و ایده‌های منتخب پس از رویداد می‌توانند وارد فرآیند
                        توسعه مرکز شده و از منتورینگ، آموزش و شبکه صنعتی آن بهره‌مند شوند، و به صورت مستمر مسیر نوآوری خود
                        را ادامه دهند.
                    </p>
                </div>
            </div>

        </section>
    )
}
export default ConnectionWithInnovationCenter;